import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";

// Action Types
export const SET_NOTIFICATION_SETTINGS = "SET_NOTIFICATION_SETTINGS";
export const GET_NOTIFICATION_SETTINGS_ERROR = "GET_NOTIFICATION_SETTINGS_ERROR";

// Thunk Action Creator
export const getNotificationSettings = createAsyncThunk(
    "api/Task/getNotificationSettings",
    async (_, { dispatch }) => {

        try {
            await axios.get(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Notification/getNotificationSettings`,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then(response => {
                    if (response.status == 200) {
                        if (response.data === '') {
                            throw new Error("The last task has not been saved. Logging the user out");
                        } else {
                            dispatch({
                                type: SET_NOTIFICATION_SETTINGS,
                                payload: response.data[0],
                            });
                        }
                    }
                    else {
                        throw new Error("Error saving user settings");
                    }
                });
        }
        catch (error) {
            dispatch({ type: GET_NOTIFICATION_SETTINGS_ERROR, payload: error });
        }
    }
);